export default {
  statuses: [],
  types: [],
  groups: []
}
